import { render, staticRenderFns } from "./RatingFilter.vue?vue&type=template&id=04c4cb78&scoped=true&"
import script from "./RatingFilter.vue?vue&type=script&lang=js&"
export * from "./RatingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c4cb78",
  null
  
)

export default component.exports